import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./types";

export const layoutSidebarSlice = createSlice({
  name: "layoutSidebar",
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
  },
});

export const { toggleSidebar } = layoutSidebarSlice.actions;
export default layoutSidebarSlice;